<!-- 안전리더십 > 컨텐츠수행 > 퀴즈형식 -->
<template>
  <div class="list-group2 ty01 mg-none" :class="{ 'disabled-block': isEndMonitoring }">
    <div class="list" v-for="(item, index) in quizData.questionList">
      <div class="row1">
        <div class="num">{{index+1}}</div>
        <div class="txt">{{item.questionTitle}}</div>
      </div>
      <div class="row2">
        <div class="radio-group3">
          <v-radio-group v-model="item.answer">
            <v-radio v-for="(item2, index2) in item.exampleList" :label="item2.exampleTitle" :value="index2+1"></v-radio>
          </v-radio-group>
        </div>
      </div>
    </div>
  </div>
  <v-snackbar v-model="snackbar" :timeout="1500" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import {ref, watch} from 'vue';
import {useCommonStore} from "@/store/common";
import utils from "@/common/Utils";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
import PdfEmbed from 'vue-pdf-embed';
import LeadershipService from "@/services/leadership.service";
import axios from "axios";
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//define
const props = defineProps(['item', 'isActive'])
const emit = defineEmits(['complete', 'save'])

//bind
const snackbar = ref(false)
const snackText = ref('')
const contentInfo:any = ref({})
const quizData:any = ref({})
const isEndMonitoring = ref(false)

//function
const getQuiz=async()=>{
  try{
    contentInfo.value = props.item
    const response = await LeadershipService.getQuiz({contentIdx:contentInfo.value.idx})
    if (response.success) {
      //데이터
      quizData.value = response.result
    } else{
      snackText.value = response.message
      snackbar.value = true
    }

    //응답처리
    if(!utils.isEmpty(quizData.value.answerList)) {
      //완료갯수 확인
      if(quizData.value.answerList.length >= contentInfo.value.periodCnt) {
        //마지막리스트로 표기
        let answer = quizData.value.answerList[0]
        emit('complete', true)
        isEndMonitoring.value = true
        _.forEach(quizData.value.questionList, async (val, key) => {
          const matched = _.find(answer.answerRowList, {questionIdx: val.idx})
          if (matched) {
            val.answer = matched.answerSeq
          }
        })
      }
    }
    else {
      emit('complete', false)
      isEndMonitoring.value = false
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const childRefSave=async()=>{
  const allAnswered = _.every(quizData.value.questionList, item => !_.isNil(item.answer) && item.answer !== 0)
  if(!allAnswered){
    snackText.value = t('message.selectAllRequired')
    snackbar.value = true
    return
  }

  try {
    const response = await LeadershipService.insertQuizAnswer(quizData.value)
    if (response.success){
      snackText.value = t('message.submissionCompleted')
      snackbar.value = true
      emit('complete', true)
      isEndMonitoring.value = true

      //완료여부 부모로 전송. 부모창에서 알아서 닫기
      emit('save', true)
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

//watch
watch(() => props.isActive, (val, oldVal) => {
  if (val)
    getQuiz()
},{ immediate: true })

//expose
defineExpose({
  childRefSave,
})

</script>


<style lang="scss" scoped>
</style>
